import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  aiIdPrefix?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, className = '', id, aiIdPrefix, ...props },
  ref,
) {
  const inputId = id || aiIdPrefix || label?.toLowerCase().replace(/\s+/g, '-');
  const hasAiId = Boolean(aiIdPrefix);

  return (
    <label className="block space-y-1.5 text-sm" htmlFor={inputId} data-ai-id={hasAiId ? aiIdPrefix : undefined}>
      {label ? (
        <span className="font-medium text-slate-700" data-ai-id={hasAiId ? `${aiIdPrefix}-label` : undefined}>
          {label}
        </span>
      ) : null}
      <input
        ref={ref}
        id={inputId}
        data-ai-id={hasAiId ? `${aiIdPrefix}-input` : undefined}
        className={[
          'w-full border border-[#ccc] bg-white px-2 py-1.5 text-[13px] text-[#333]',
          'placeholder:text-[#999] focus:border-[#66afe9] focus:outline-none focus:ring-4 focus:ring-[#66afe9]/30 transition-shadow',
          error ? 'border-[#a94442] focus:border-[#a94442] focus:ring-[#a94442]/30' : '',
          className,
        ].join(' ')}
        {...props}
      />
      {error ? (
        <p className="text-xs text-rose-600" data-ai-id={hasAiId ? `${aiIdPrefix}-error` : undefined}>
          {error}
        </p>
      ) : null}
    </label>
  );
});
